/**
 * User management & login
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('member.internships', {
            url: '/' + urls.member.internships.fr, // TODO : when multilang, change this to something dynamic
            views: {
                aside: {
                    templateUrl: 'src/views/member/member_aside.html'
                },
                content: {
                    controller: ['$scope', '$rootScope', '$filter', 'drupal', 'moment', 'FileSaver', 'Blob', 'tools', 'filterFilter', 'utils', function ($scope, $rootScope, $filter, $drupal, moment, $filesaver, Blob, tools, filterFilter, utils) {
                        // remove warning message
                        if ($scope.teaserPanel.css === 'info') {
                            angular.merge($scope.teaserPanel, { css: null, body: null });
                        }

                        if ($scope.breadcrumb.length > 2) {
                            $scope.breadcrumb.pop();
                        }
                        var sInternships = $filter('translate')('account.internshipsMonitor');
                        $scope.breadcrumb.push({ label: sInternships, state: 'member.internships.list' });
                        $rootScope.title = $filter('translate')('account.title') + ' - ' + sInternships.toLowerCase();
                        $rootScope.titlePanel = sInternships;

                        ///////////////////////////////////////////////////

                        $scope.minDate = moment().format('MM/DD/YYYY');
                        $scope.currentDate = moment().format("DD MMMM");
                        $scope.config = $rootScope.config.site;

                        $scope.pending = true;
                        // filters model
                        $scope.filtersReady = false;

                        $scope.dateRegex = new RegExp("^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$");

                        // limit number of internships to display
                        $scope.step = 50;
                        $scope.limit = 50;
                        $scope.showMoreLabel = tools.replace($filter('translate')('internship.showMore'), { number: $scope.step });
                        // show more results
                        $scope.showMore = function () {
                            $scope.limit += $scope.step;
                        };
                        $scope.resetMore = function () {
                            $scope.limit = 50;
                        };

                        $scope.filters = {
                            activityOpen: false,
                            activitySilent: false,
                            activity: [],
                            input: {
                                startDate: '',
                                endDate: '',
                                activity: 'all'
                            }
                        };

                        // var filteredWords = ['multi', 'gestion', 'kay', 'kite'];
                        var filteredWords = ['multi-activit', 'kay', 'kite'];
                        $scope.filterRenaming = [
                            {
                                name:"Gestion",
                                rename:"MDM"
                            },
                            {
                                name:"Multi-voiles",
                                rename:"Groupes"
                            },
                        ]
                        $scope.activities = function activities() {
                            return filterFilter($scope.filters.activity, { selected: true });
                        };
                        $drupal.getCriteria().then(function(criterias) {
                            if (criterias.filters && criterias.filters.activity && criterias.filters.activity.options) {
                                $scope.filters.activity = criterias.filters.activity.options.filter(function (o) {
                                    return !filteredWords.some(function (word) {
                                        return o.name.toLowerCase().indexOf(word) > -1;
                                    });
                                });
                            }
                            $scope.filtersReady = true;
                            $scope.doConfirmFilter();
                        });

                        $scope.$watch('filters.input', function (input) {
                            $scope.doFilter();
                        }, true);

                        // retrieve internships list
                        $scope.internshipsData = {
                            filtered: [],
                            full: [],
                        };

                        // do filter
                        $scope.doFilter = function () {
                            $scope.doFilterCollection($scope.internshipsData);
                            $scope.resetMore();
                        };

                        var filterRenaming = [
                            {
                                name:"Gestion",
                                rename:"MDM"
                            },
                            {
                                name:"Multi-voiles",
                                rename:"Groupes"
                            },
                        ]
                        $scope.renameFilter = (function(element) {
                            var renaming = element;
                            filterRenaming.forEach(function(e){
                                if(e.name === element){
                                    renaming = e.rename;
                                }
                            })
                            return renaming
                        });

                        // filter functions
                        $scope.doFilterCollection = function (collection) {
                            collection.filtered = collection.full.filter(function (internship) {
                                var isvalid = true;
                                if ($scope.filters.input.activity !== 'all') {
                                    if ($scope.filters.input.activity !== internship.filiere) {
                                        isvalid = false;
                                    }
                                }
                                if ($scope.filters.input.startDate !== '') {
                                    //var filteredDate = moment($scope.filters.input.startDate, ["DD/MM/YYYY"]).subtract(15, 'days');
                                    var filteredDate = moment($scope.filters.input.startDate, ["DD/MM/YYYY"]);
                                    if (filteredDate.isValid()
                                        && !filteredDate.isSameOrBefore(internship.dateDebutStage)) {
                                        isvalid = false;
                                    }
                                }
                                if ($scope.filters.input.endDate !== '') {
                                    var filteredDate = moment($scope.filters.input.endDate, ["DD/MM/YYYY"]).add(15, 'days');
                                    if (filteredDate.isValid()
                                        && !filteredDate.isSameOrAfter(internship.dateFinStage)) {
                                        isvalid = false;
                                    }
                                }
                                return isvalid;
                            });
                        };
                        $scope.doConfirmFilter = function () {
                            if ($scope.filtersReady === true && $scope.pending === false) {
                                for(var i = $scope.filters.activity.length - 1; i >= 0; i--) {
                                    var collectionConfirmFilter = $scope.internshipsData.full.filter(function (internship) {
                                        if ($scope.filters.activity[i].name !== internship.filiere) {
                                            return false;
                                        }
                                        return true;
                                    });

                                    if (collectionConfirmFilter.length === 0) {
                                        $scope.filters.activity.splice(i, 1);
                                    }
                                }
                            }
                        };
                        $scope.clearFilter = function () {
                            $scope.filters.input.activity = 'all';
                            $scope.filters.input.startDate = '';
                            $scope.filters.input.endDate = '';
                            $scope.doFilter();
                        };

                        // retrieve internships from api
                        $drupal.getInternshipsSupervised().then(function (internships) {
                            for (var i = 0 ; i < internships.length ; i++) {
                                var language = internships[i].language.split(' - ');
                                internships[i].language = "";
                                language.forEach(function(element) {
                                    element = element.substring(0, 3);
                                    element += ", ";
                                    internships[i].language += element;
                                });
                                internships[i].language = internships[i].language.substring(0, internships[i].language.length - 2);
                                $scope.internshipsData.full.push(internships[i]);
                            }
                            //$scope.internshipsData.full = internships;
                            $scope.doFilter();
                        }).finally(function () {
                            $scope.pending = false;
                            $scope.doConfirmFilter();
                        });

                        $scope.pendingExport = false;
                        $scope.export = function () {

                            if (!$scope.pendingExport) {
                                $scope.pendingExport = true;

                                var sortedInternships = $scope.internshipsData.filtered.sort(function (a, b) {
                                    return new Date(a.dateDebutStage).getTime() - new Date(b.dateDebutStage).getTime();
                                });
                                var internshipData = $scope.formatInternshipData(sortedInternships);

                                //var data = new Blob([[$filter('translate')('supervision.contentDescriptionStart')+moment().format("DD MMMM")+$filter('translate')('supervision.contentDescriptionEnd')].join('\n') + '\n', internshipData.join('\n')], { type: 'text/csv;charset=utf-8' });
                                var data = new Blob([internshipData.join('\n')], { type: 'text/csv;charset=utf-8' });
                                $filesaver.saveAs(data, 'export-stages-a-encadrer-' + moment().format('DD_MM_YY') + '.csv');

                                $scope.pendingExport = false;
                            }
                        }

                        $scope.formatInternshipData = function (entries) {
                            var result = [
                                $filter('translate')('supervision.base'),
                                $filter('translate')('supervision.audience'),
                                $filter('translate')('supervision.category'),
                                $filter('translate')('supervision.level'),
                                $filter('translate')('supervision.internship'),
                                $filter('translate')('supervision.start'),
                                $filter('translate')('supervision.end'),
                                $filter('translate')('supervision.duration'),
                                $filter('translate')('supervision.lang')
                            ].join(';');
                            return [result].concat(entries.map(function (entry) {
                                return [
                                    entry.base,
                                    entry.audience,
                                    entry.filiere,
                                    entry.level,
                                    entry.productName,
                                    moment(entry.dateDebutStage).format('DD/MM/YY'),
                                    moment(entry.dateFinStage).format('DD/MM/YY'),
                                    entry.duree,
                                    entry.language
                                ].join(';');
                            }));
                        };
                        utils.calendarTrad()
                        $scope.initDatepicker = function(){
                            utils.calendarTrad()
                        }
                    }],
                    templateUrl: 'src/views/member/member_internships.html'
                }
            }
        });
}]);
